// delay function to use on resize to prevent multiple resize events
const delay = (function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();


// SCROLL --- SCROLL --- SCROLL --- SCROLL --- SCROLL ---
const checkForOverflow = function () {
  const tabsSection = document.querySelector('.s-tabs-section__nav');
  const tabsSectionContainer = document.querySelector('.s-tabs-section');
  const tabsSectionArrow = document.querySelector('.s-tabs-section__arrow');

  let tabSectionOffTheScreen = tabsSection.scrollWidth - tabsSectionContainer.clientWidth;

  // Check to see if the tab area is wider than visible width, if so show arrow
  if (tabSectionOffTheScreen >= 0) {
    tabsSectionArrow.classList.add('s-tabs-section__arrow--visible');
  } else {
    tabsSectionArrow.classList.remove('s-tabs-section__arrow--visible');
  }
  let readyToScrollBack = false

  // Make arrow clickable and scroll the navigation

  tabsSectionArrow.addEventListener('click', () => {

    // if some of the element off screen scoll by 150px and minus 150 from tabSectionOffTheScreen
    if (tabSectionOffTheScreen > 1) {
      tabsSection.scrollBy({
        left: 150,
        behavior: 'smooth'
      })
      tabSectionOffTheScreen = tabSectionOffTheScreen - 150;
      // console.log(tabsSectionContainer.clientWidth);
      // console.log(tabsSection.clientWidth);
      // console.log(tabSectionOffTheScreen);
    }

    // once arrow is rotated and readyToScrollBack true (see below) ... then scoll the element back to the start
    if (tabSectionOffTheScreen < 1 && readyToScrollBack) {
      tabsSection.scroll({
        left: 0,
        behavior: 'smooth'
      })
      tabSectionOffTheScreen = tabsSection.offsetWidth
      tabsSectionArrow.classList.remove('s-tabs-section__arrow--rotate');
      readyToScrollBack = false
    }

    // check scroll is at the end, rotate the arrow and then set the readyToScrollBack to true for the next click
    if (tabSectionOffTheScreen < 1 && !readyToScrollBack) {
      tabsSectionArrow.classList.add('s-tabs-section__arrow--rotate');

      readyToScrollBack = true

    }
  })


  //check for touch dragging and rotate the arrow when at the end
  // tabsSection.addEventListener('scroll', function (e) {
  //   tabsSectionArrow.classList.remove('s-tabs-section__arrow--visible');
  // });

};


const tabsSection = document.querySelector('.s-tabs-section');
if (tabsSection) {
  new Tabby('[data-tabs-section]');
  checkForOverflow();

  // window resize
  window.onresize = function (event) {
    delay(function () {
      checkForOverflow();
    }, 500);
  };

  new ScrollBooster({
    viewport: document.querySelector('.s-tabs-section__nav'),
    content: document.querySelector('.s-tabs-section__content'),
    scrollMode: 'native',
    direction: 'horizontal',
    bounce: false,
    pointerMode: 'mouse'
  });

  // Detect when position sticky is "stuck" and apply a class
  const tabsSectionWrapper = document.querySelector('.s-tabs-section-wrapper');
  const observer = new IntersectionObserver(([e]) => {
    e.target.classList.toggle('s-tabs-section-wrapper--is-sticky', e.boundingClientRect.top < 0)
  },
    { threshold: [1] }
  );
  observer.observe(tabsSectionWrapper)

}


